module.exports = __webpack_public_path__ + "media/images/ln-img6-d11b28d6e76dd73148af28c5a44178cd.png";